import { css } from '@emotion/core';
import { variables, pTag } from '@domain-group/fe-brary';
var font = variables.font,
  colour = variables.colour;
export var base = /*#__PURE__*/css("color:", colour.neutral700, ";.expander__view-more-label{font-size:", font.smallFontSize, ";font-weight:", font.headingFontWeight, ";}button:focus{outline:none;}");
export var columns = {
  name: "13pmxen",
  styles: "display:flex;flex:1;"
};
export var columnLeft = {
  name: "1rr4qq7",
  styles: "flex:1;"
};
export var columnRight = {
  name: "1cxog5s",
  styles: "width:20%;height:60px;"
};
export var logo = {
  name: "1hyqth2",
  styles: "max-height:100%;max-width:100%;"
};
export var title = /*#__PURE__*/css("font-family:", font.headingFontFamily, ";font-size:", font.h3FontSize, ";font-weight:", font.headingFontWeight, ";");
export var name = {
  name: "1r2f04i",
  styles: "margin-bottom:10px;"
};
export var content = /*#__PURE__*/css("p{", pTag, ";}strong{font-weight:bold;}em{font-style:italic;}u{text-decoration:underline;}li{margin-bottom:3px;}ol{", pTag, ";list-style:decimal;}ul{", pTag, ";list-style:disc;}ul,ol{margin-left:10px;padding-left:10px;}");
export var smallFont = /*#__PURE__*/css("font-size:", font.smallFontSize, ";", content);